/**
 * ============================================================================
 * ไฟล์เดียวสำหรับแก้ตอนเปิดรอบใหม่ / เปลี่ยนข้อความสถานะ
 * ============================================================================
 *
 * วิธีใช้ตอนเปิดรอบ:
 * 1) ใส่ ROB_ID จริงในตารางปุ่มของหน้านั้น
 *    NORMAL_ROUND_BUTTONS   /Register/1  ปริญญาตรี ภาคปกติ + พยาบาล
 *    WEEKEND_ROUND_BUTTONS  /Register/2  ปริญญาตรี กศ.บป.
 *    ASSIST_ROUND_BUTTONS   /Register/0  ป.บัณฑิต ผู้ช่วยพยาบาล
 *    TEACHER_ROUND_BUTTONS  /Register/5  ป.บัณฑิต วิชาชีพครู
 * 2) ตั้ง open: true รอบที่เปิดรับ (false = จาง กดไม่ได้)
 * 3) อัปเดต ROB_GROUPS ถ้ารอบใหม่ต้องโชว์ห้องสัมภาษณ์ / ล็อกแก้เอกสาร ฯลฯ
 * 4) แก้ MESSAGES ข้อความวันที่ประกาศ / เปิดรอบถัดไป
 * 5) แก้ PRINT_DEADLINE ถ้าต้องกำหนดวันเริ่มพิมพ์ใบสมัคร
 *
 * แล้ว build/deploy (หรือ hot reload บน :3000)
 * ============================================================================
 */

import { ACADEMIC_YEAR } from "./academicYear";
import { site } from "./api";


/** ปีการศึกษาปัจจุบัน (อิง .env) — ใช้ประกอบข้อความได้ */
export { ACADEMIC_YEAR };

// ---------------------------------------------------------------------------
// 1) ปุ่มเลือกรอบหน้า /Register/1 และ /Register/2
//    id = ROB_ID จากระบบหลังบ้าน | open = เปิดรับสมัครหรือไม่
// ---------------------------------------------------------------------------

/**
 * ภาคปกติ + พยาบาล  (/Register/1)
 * group = แถวที่ปุ่มจะไปอยู่ (ดู NORMAL_ROUND_GROUPS) — เพิ่ม/ลบปุ่มได้อิสระ
 * ไม่ต้องนับจำนวนปุ่มต่อแถวเองอีก
 */
export const NORMAL_ROUND_BUTTONS = [
  { key: "rob1", id: '198', open: true, label: "รอบ 1", group: "regular" }, // เช่น "173"
  { key: "rob2", id: '201', open: false, label: "รอบ 2", group: "regular" }, // เช่น "176"
  { key: "rob3", id: '204', open: false, label: "รอบ 3", group: "regular" }, // เช่น "179"
  { key: "rob4", id: '207', open: false, label: "รอบ 4", group: "regular" },
  { key: "rob5", id: '210', open: false, label: "รอบ 5", group: "regular" },
  { key: "nrob1", id: '213', open: true, label: "พยาบาล รอบ 1", group: "nurse" }, // เช่น "185"
  { key: "nrob2", id: '214', open: false, label: "พยาบาล รอบ 2", group: "nurse" }, // เช่น "186"
];

/** ลำดับแถวของปุ่มในหน้า /Register/1 */
export const NORMAL_ROUND_GROUPS = [
  { key: "regular", label: "รอบรับสมัครทั่วไป" },
  { key: "nurse", label: "หลักสูตรพยาบาลศาสตรบัณฑิต" },
];

/** กศ.บป. (/Register/2) */
export const WEEKEND_ROUND_BUTTONS = [
  { key: "wrob1", id: '215', open: true, label: "กศ.บป. รอบ 1", group: "weekend" }, // เช่น "187"
  { key: "wrob2", id: '216', open: false, label: "กศ.บป. รอบ 2", group: "weekend" }, // เช่น "188"
  { key: "wrob3", id: '217', open: false, label: "กศ.บป. รอบ 3", group: "weekend" }, // เช่น "188"
];

/** ลำดับแถวของปุ่มในหน้า /Register/2 */
export const WEEKEND_ROUND_GROUPS = [{ key: "weekend", label: null }];

/**
 * ประกาศนียบัตรบัณฑิต สาขาผู้ช่วยพยาบาล (/Register/0)
 * ROB_ID ของหน้านี้อยู่ใน QUOTA_ID 38 — ดูได้จาก /administrator/rob
 */
export const ASSIST_ROUND_BUTTONS = [
  { key: "arob1", id: '221', open: true, label: "ผู้ช่วยพยาบาล รอบ 1", group: "assist" },
  { key: "arob2", id: '222', open: false, label: "ผู้ช่วยพยาบาล รอบ 2", group: "assist" },
  { key: "arob3", id: '223', open: false, label: "ผู้ช่วยพยาบาล รอบ 3", group: "assist" },
];

/** ลำดับแถวของปุ่มในหน้า /Register/0 */
export const ASSIST_ROUND_GROUPS = [{ key: "assist", label: null }];

/**
 * ประกาศนียบัตรบัณฑิต สาขาวิชาชีพครู (/Register/5)
 * ROB_ID ของหน้านี้อยู่ใน QUOTA_ID 29 — ดูได้จาก /administrator/rob
 */
export const TEACHER_ROUND_BUTTONS = [
  { key: "trob1", id: '224', open: true, label: "วิชาชีพครู รอบ 1", group: "teacher" },
  { key: "trob2", id: '225', open: false, label: "วิชาชีพครู รอบ 2", group: "teacher" },
];

/** ลำดับแถวของปุ่มในหน้า /Register/5 */
export const TEACHER_ROUND_GROUPS = [{ key: "teacher", label: null }];

/** ROB_ID ของปุ่มพยาบาล (group nurse) + รอบปีเก่าที่ยังมีผู้สมัครค้าง */
export function nurseRoundIds() {
  const fromButtons = NORMAL_ROUND_BUTTONS.filter(
    (round) => round.group === "nurse" && round.id != null && String(round.id).trim() !== ""
  ).map((round) => String(round.id));
  return Array.from(new Set(fromButtons.concat(["185", "186", "191"])));
}

export function isNurseRound(robId) {
  return nurseRoundIds().includes(String(robId));
}

/**
 * แปลงปุ่มใน config ให้พร้อมใช้งาน
 * id ว่าง/null = ยังไม่ผูก ROB_ID → ถือว่าปิดรับสมัครเสมอ
 */
export function resolveRoundButton(round) {
  const id = round.id != null && String(round.id).trim() !== "" ? String(round.id) : null;
  return { ...round, id, open: Boolean(round.open) && id != null };
}

/** จัดปุ่มเข้าแถวตาม group ที่กำหนด (แถวที่ไม่มีปุ่มจะถูกตัดออก) */
export function groupRoundButtons(rounds, groups, images) {
  return groups
    .map((group) => ({
      ...group,
      items: rounds
        .filter((round) => round.group === group.key)
        .map((round) => ({ ...resolveRoundButton(round), src: images[round.key] })),
    }))
    .filter((group) => group.items.length > 0);
}

// ---------------------------------------------------------------------------
// 2) กลุ่ม ROB_ID — เงื่อนไขแสดงผลตามรอบ (แทนการ || ทีละตัวในหลายไฟล์)
// ---------------------------------------------------------------------------

export const ROB_GROUPS = {
  /** แสดงห้องสอบสัมภาษณ์ใน DetailRegister_1 */
  showInterviewRoom: ["179", "183", "184", "186", "191", "182", "187"],

  /** StatusRegister_1: มีสิทธิ์สัมภาษณ์ (รอบทั่วไป) */
  statusInterviewEligible: ["186", "179", "182"],

  /** StatusRegister_1 / DetailClassInterviwe: รอบ portfolio พิเศษ */
  statusPortfolioRound: ["183", "184"],

  /** DetailComment: หมายเหตุสัมภาษณ์แบบย่อ */
  commentInterviewNote: ["177", "178"],

  /** FileManage: ห้ามแก้เอกสารวุฒิ */
  disableEditVut: [
    "173",
    "174",
    "175",
    "185",
    "176",
    "178",
    "177",
    "191",
    "189",
    "190",
  ],
};

/** รหัสสาขาที่เข้าเงื่อนไข portfolio / บางข้อความพิเศษ */
export const PORTFOLIO_MAJOR_CODES = [
  "1101",
  "1102",
  "1103",
  "1106",
  "1110",
  "1207",
  "1208",
  "1301",
  "1302",
  "1304",
  "1310",
];

export function isRobIn(groupKey, robId) {
  const list = ROB_GROUPS[groupKey] || [];
  return list.map(String).includes(String(robId));
}

export function isPortfolioMajor(majorId) {
  return PORTFOLIO_MAJOR_CODES.map(String).includes(String(majorId));
}

// ---------------------------------------------------------------------------
// 3) ข้อความที่แก้บ่อย — วันที่ประกาศ / เปิดรอบถัดไป / หมายเหตุ
// ---------------------------------------------------------------------------

export const MESSAGES = {
  /** สถานะมีสิทธิ์สัมภาษณ์ */
  interviewEligible: "มีสิทธิ์เข้ารับการสอบสัมภาษณ์",

  /** รอประกาศผู้ผ่าน (เช่น StatusRegister_1) */
  waitAnnouncePass: "รอประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 9 เมษายน 2569",

  /** ไม่ต้องสัมภาษณ์ (DetailClassInterviweLevel1) */
  noInterviewAnnounce:
    "ไม่ต้องเข้ารับการสอบสัมภาษณ์ จะประกาศรายชื่อผู้ผ่านการคัดเลือก วันที่ 9 เมษายน 2569 เวลา 18.00 น.",

  /** หมายเหตุหลังประกาศสิทธิ์สัมภาษณ์ */
  noteStudyInterviewAnnounce:
    "หมายเหตุ : ให้ผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ",

  noteStudyInterviewAnnounceShort:
    "หมายเหตุ : ศึกษารายละเอียดในประกาศรายชื่อผู้มีสิทธิ์เข้ารับการสอบสัมภาษณ์ฯ",

  /** บัณฑิต: วันพิมพ์ใบสมัคร */
  notePrintFormGraduate: "หมายเหตุ : พิมพ์ใบสมัครได้ในวันที่ 21-24 เมษายน 2569",

  /** ไม่ผ่าน — โฆษณารอบถัดไป (StatusRegister_11) */
  nextRoundOpenHint:
    "จะเปิดรับสมัครรอบ 4 ตั้งแต่วันที่ 21 เมษายน 2569 - 7 มิถุนายน 2569",

  /** รายงานตัวหลังชำระ (StatusRegister_6) */
  reportAfterPay:
    "เมื่อชำระเงินค่าธรรมเนียมการศึกษาเรียบร้อยแล้ว ให้กรอกข้อมูลรายงานตัว ในวันที่ 1 - 30 เมษายน 2569 ผ่านเว็บไซต์ " + site,

  /** StatusRegister_4 — ข้อความตามประเภท (แก้ตรงนี้เมื่อเปลี่ยนปฏิทิน) */
  admitNurseBodyExam:
    "ส่งผลการตรวจร่างกายฉบับจริง ตั้งแต่วันนี้ ถึงวันที่ 30 เมษายน - 5 พฤษภาคม 2569 ณ อาคารศูนย์ปฏิบัติการพยาบาล คณะพยาบาลศาสตร์ มหาวิทยาลัยราชภัฏกำแพงเพชร",
  admitNurseAnnounce:
    "ประกาศรายชื่อผู้มีสิทธิ์เข้าศึกษา ภาคปกติ คณะพยาบาลศาสตร์ วันที่ 7 พฤษภาคม 2569",
  admitPayWindowFeb:
    "1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 20 กุมภาพันธ์ - 1 มีนาคม 2569 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์",
  admitPayWindowMay11_14:
    "1. ผู้มีสิทธิ์เข้าศึกษายืนยันสิทธิ์และชำระเงินค่าธรรมเนียมการศึกษา ตั้งแต่วันที่ 11 - 14 พฤษภาคม 2569 หากพ้นกำหนดจะถือว่าสละสิทธิ์ในการเข้าเป็นนักศึกษา",
  admitPayWindowMay11_15:
    "1. ผู้มีสิทธิ์เข้าศึกษายืนยันสิทธิ์และชำระเงินค่าธรรมเนียมการศึกษา ตั้งแต่วันที่ 11 - 15 พฤษภาคม 2569",
  admitPayWindowApr9_15:
    "1. ผู้มีสิทธิ์เข้าศึกษา สามารถยืนยันสิทธิ์ และชำระค่าธรรมเนียมการศึกษาได้ตั้งแต่วันที่ 9 - 15 เมษายน 2569 หากไม่ชำระค่าธรรมเนียมการศึกษาภายในเวลาที่กำหนด จะถือว่าสละสิทธิ์",
  admitReserveAnnounceApr17:
    "2. ผู้ที่ได้รับการคัดเลือกเป็นตัวสำรอง มหาวิทยาลัยฯ จะประกาศผลการคัดเลือก เข้าศึกษาต่อเพิ่มเติมสำหรับทะเบียนสำรอง (ตัวสำรอง)  ในวันที่ 17 เมษายน 2569",
};

// ---------------------------------------------------------------------------
// 4) วันเริ่มพิมพ์ใบสมัคร (AllowPermission.PrintRegist)
//    รูปแบบ: "MM/DD/YYYY HH:mm" (ปี ค.ศ.) — ก่อนวันนี้พิมพ์ได้
// ---------------------------------------------------------------------------

export const PRINT_DEADLINE = {
  default: "12/12/2025 18:00",
  byRobId: {
    "151": "03/18/2025 18:00",
    "152": "12/12/2028 09:00",
    "154": "04/25/2025 18:00",
    "156": "02/14/2025 10:00",
    "159": "02/14/2025 10:00",
    "160": "04/14/2025 18:00",
    "161": "04/14/2025 18:00",
    "164": "05/13/2025 18:00",
    "169": "08/18/2025 18:00",
    "170": "08/18/2025 18:00",
    "171": "09/11/2025 18:00",
  },
  /** รอบที่ต้องแยกตามสาขา */
  byRobIdMajor: {
    "153": {
      majors: ["1202", "1207", "1208", "1301", "1110", "1304", "1310"],
      match: "12/12/2024 09:00",
      other: "12/27/2024 18:00",
    },
    "155": {
      majors: ["1202", "1207", "1208", "1301", "1110", "1304", "1310"],
      match: "12/12/2024 09:00",
      other: "12/27/2024 18:00",
    },
  },
  /** กรณีพิเศษ 151 + สาขาพยาบาล */
  rob151Major8201: "01/31/2025 09:00",
  /** 157/158 + สาขาพิเศษจาก Major1 */
  rob157158SpecialMajors: ["1202", "1207", "1208", "1110"],
  rob157158Match: "02/14/2025 10:00",
  rob157158Other: "02/14/2028 10:00",
};

/**
 * คืนวันสิ้นสุดที่พิมพ์ใบสมัครได้ (ก่อนเวลานี้ = อนุญาต)
 * logic เดิมจาก AllowPermission.PrintRegist
 */
export function resolvePrintDeadline(ROB_ID, MAJOR_ID, DataRegister) {
  const rob = String(ROB_ID);
  const major = String(MAJOR_ID || "");

  if (rob === "151") {
    return major === "8201"
      ? PRINT_DEADLINE.rob151Major8201
      : PRINT_DEADLINE.byRobId["151"];
  }

  const majorRule = PRINT_DEADLINE.byRobIdMajor[rob];
  if (majorRule) {
    return majorRule.majors.map(String).includes(major)
      ? majorRule.match
      : majorRule.other;
  }

  if (rob === "157" || rob === "158") {
    const m1 = DataRegister?.[0]?.Major1_MAJOR_ID;
    const special = PRINT_DEADLINE.rob157158SpecialMajors.map(String);
    return special.includes(String(m1))
      ? PRINT_DEADLINE.rob157158Match
      : PRINT_DEADLINE.rob157158Other;
  }

  if (PRINT_DEADLINE.byRobId[rob]) {
    return PRINT_DEADLINE.byRobId[rob];
  }

  return PRINT_DEADLINE.default;
}
